import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import env from 'react-dotenv';
import { SucessData, ErrorData, StoreStateData } from '.';

const SIGLA_SISTEMA = 'CNMP';

enum StorageKeys {
  token = 'token',
  tokenExpirationDate = 'tokenExpirationDate',
}

const retrieveToken = () => {
  const tokenExpirationDateString = localStorage.getItem(StorageKeys.tokenExpirationDate);

  if (tokenExpirationDateString && tokenExpirationDateString !== null) {
    const tokenExpirationDate = new Date(tokenExpirationDateString);
    if (new Date() > tokenExpirationDate) {
      localStorage.removeItem(StorageKeys.tokenExpirationDate);
      localStorage.removeItem(StorageKeys.token);
    }
  }

  const token = localStorage.getItem(StorageKeys.token);
  return token;
};

type AuthState = StoreStateData & {
  isAuthenticated: boolean;
};

const token = retrieveToken();

const initialState: AuthState = {
  token: token ? token : '',
  error: '',
  isAuthenticated: !!token,
  status: 'uninitiated',
};

const fetchToken = createAsyncThunk<
  SucessData,
  { login?: string; senha?: string },
  {
    rejectValue: ErrorData;
  }
>(
  'auth/fetchToken',
  async ({ login, senha }: { login?: string; senha?: string }, { rejectWithValue }) => {
    if (!login || !senha) {
      return rejectWithValue({
        error: 'Login e senha são necessários.',
      });
    }

    const response = await fetch(`${env.AUTH_API}/acesso/autoriza`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        login,
        senha,
        siglaSistema: SIGLA_SISTEMA,
      }),
    });
    if (response.status === 200) {
      const data: SucessData = await response.json();
      return { data, status: 'completed', token: data.token };
    } else if (response.status >= 400 && response.status < 500) {
      return rejectWithValue({
        error: 'Erro na autenticação.',
      });
    } else {
      return rejectWithValue({
        error: 'Login ou senha não conferem',
      });
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logoff(state) {
      state.isAuthenticated = false;
      localStorage.removeItem(StorageKeys.token);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchToken.pending, (state, action) => {
      state.status = 'pending';
    });
    builder.addCase(fetchToken.fulfilled, (state, { payload }) => {
      localStorage.setItem(StorageKeys.token, payload.token);

      const expirationDate: Date = new Date(new Date().getTime() + 3 * 60000);
      localStorage.setItem(StorageKeys.tokenExpirationDate, expirationDate.toISOString());
      state.error = '';
      state.isAuthenticated = true;
      state.status = 'completed';
      state.token = payload.token;
    });
    builder.addCase(fetchToken.rejected, (state, { payload }) => {
      if (payload) {
        state.error = payload.error;
      } else {
        state.error = 'Something wrong.';
      }
      state.token = '';
      state.isAuthenticated = false;
      state.status = 'completed';
    });
  },
});

export const authActions = { ...authSlice.actions, fetchToken };
export default authSlice.reducer;
